var _defs, _circle, _circle2, _circle3, _circle4, _text, _rect, _circle5, _text2, _rect2, _circle6, _text3, _rect3, _circle7, _text4, _rect4, _circle8, _text5, _path, _circle9, _circle0, _circle1, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutAndusHeroPeopleProcessDataSystemOrbitDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 690,
    height: 610,
    viewBox: "0 0 690 610",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "People, processes, data and systems connected around applied intelligence") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "aboutHeroGlow"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BCBFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD0E2",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aboutHeroRing"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8BCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 300,
    r: 270,
    fill: "url(#aboutHeroGlow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 300,
    r: 195,
    fill: "none",
    stroke: "#8BCBFF",
    strokeOpacity: 0.52
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 300,
    r: 136,
    fill: "none",
    stroke: "#FF91BA",
    strokeOpacity: 0.34,
    strokeDasharray: "4 8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 300,
    r: 90,
    fill: "#07152A",
    stroke: "url(#aboutHeroRing)",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 288,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 21,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 345,
    dy: 0
  }, "APPLIED"), /*#__PURE__*/React.createElement("tspan", {
    x: 345,
    dy: 26
  }, "INTELLIGENCE"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 52,
    width: 174,
    height: 70,
    rx: 15,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#C9DDF1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 87,
    r: 7,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 79,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 58,
    dy: 0
  }, "PEOPLE"), /*#__PURE__*/React.createElement("tspan", {
    x: 58,
    dy: 18
  }, "Roles and decisions"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 52,
    width: 174,
    height: 70,
    rx: 15,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#C9DDF1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 521,
    cy: 87,
    r: 7,
    fill: "#FF2775"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 538,
    y: 79,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 538,
    dy: 0
  }, "PROCESS"), /*#__PURE__*/React.createElement("tspan", {
    x: 538,
    dy: 18
  }, "Flow and controls"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 484,
    width: 174,
    height: 70,
    rx: 15,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#C9DDF1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 519,
    r: 7,
    fill: "#30D6A1"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 511,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 58,
    dy: 0
  }, "DATA"), /*#__PURE__*/React.createElement("tspan", {
    x: 58,
    dy: 18
  }, "Evidence and insight"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 484,
    width: 174,
    height: 70,
    rx: 15,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#C9DDF1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 521,
    cy: 519,
    r: 7,
    fill: "#F4B63D"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 538,
    y: 511,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 538,
    dy: 0
  }, "SYSTEMS"), /*#__PURE__*/React.createElement("tspan", {
    x: 538,
    dy: 18
  }, "Tools and integration"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 122 Q310 208 321 212       M498 122 Q380 208 369 212       M192 484 Q307 395 318 386       M498 484 Q383 395 372 386",
    fill: "none",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 122,
    r: 4,
    fill: "#087CFF"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 122,
    r: 4,
    fill: "#FF2775"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 484,
    r: 4,
    fill: "#30D6A1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 484,
    r: 4,
    fill: "#F4B63D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAndusHeroPeopleProcessDataSystemOrbitDesktop);
export default __webpack_public_path__ + "static/media/about-andus-hero-people-process-data-system-orbit-desktop.878f54523a1b9ca2738bd38436bb6c91.svg";
export { ForwardRef as ReactComponent };